import AdjoyApproveCampaign from './components/AdjoyApproveCampaign';
import './assets/AdjoyApproveCampaign.css';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter';
import { connect } from 'react-redux';
import get from 'lodash/get';
import values from 'lodash/values';
import {
  loadCampaign,
  loadEngagementsForCampaign,
  loadActiveUser,
  updateCampaign,
  adjoyApproveCampaign,
  adjoyRejectCampaign,
  loadBrand,
  loadRetailers,
  loadPaymentMethodsForAgency,
  loadPublishersForCampaign,
  loadCampaignReach
} from '../../shared/redux/entities/actions';


import { showNotification } from '../../shared/redux/notifications/actions';

import { 
  loadListOfStates,
  loadListOfStatesAndDMAs 
} from '../../shared/redux/audience/actions';

function getEngagementsForCampaignId(state,campaignId){
  return values(get(state,['entities','engagements'],{}))
    .filter((e) => e.campaignId === campaignId)
    .sort((a,b) => a.ordinal - b.ordinal);
}

function getBrandForCampaignId(state,campaignId){
  const companyId = get(state,['entities','campaigns',campaignId,'companyId']);

  return get(state,['entities','companies',companyId],{});
}

function getPaymentMethodForCampaignId(state,campaignId){
  const paymentMethodId = get(state,['entities','campaigns',campaignId,'paymentMethodId']);

  return get(state,['entities','paymentMethods',paymentMethodId],{});
}

function getPublishersForCampaignId(state,campaignId){
  const companyId = get(state,['entities','campaigns',campaignId,'companyId']);

  const matchingRetailers = values(state.entities.companies)
    .filter((c) => !c.isBrand)
    .filter((c) => (c.approvedBrandIds || []).indexOf(companyId) >= 0);

  return matchingRetailers;
}

function getRetailers(state){
  return values(state.entities.companies).filter((c) => !c.isBrand)
}

function mapStateToProps(state,props){
  const campaignId = props.campaignId;

  return {
    campaignId:campaignId,
    campaign:get(state,['entities','campaigns',campaignId],{}),
    paymentMethodId:get(state,['entities','campaigns',campaignId,'paymentMethodId']),
    paymentMethod:getPaymentMethodForCampaignId(state,campaignId),
    engagements:getEngagementsForCampaignId(state,campaignId),
    brand:getBrandForCampaignId(state,campaignId),
    retailers:getRetailers(state),
    activeUserId:get(state,['entities','activeUserId']),
    possibleStates:state.audience.states,
    possibleGeoFilters:state.audience.geofilters
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadActiveUser,
    loadCampaign,
    updateCampaign,
    loadEngagementsForCampaign,
    loadPaymentMethodsForAgency,
    adjoyApproveCampaign,
    adjoyRejectCampaign,
    loadBrand,
    loadRetailers,
    showNotification,
    loadPublishersForCampaign,
    loadListOfStates,
    loadCampaignReach,
    loadListOfStatesAndDMAs
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(AdjoyApproveCampaign));



// WEBPACK FOOTER //
// ./src/routes/AdjoyApproveCampaign/index.js